import { Instagram, Twitter, Youtube } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative bg-black border-t border-neutral-900 pt-20 pb-10 overflow-hidden"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="/brand/logo.png"
                alt="AfroAm Basketball Association"
                className="h-14 w-auto object-contain"
              />
              <div className="font-display text-4xl uppercase text-white leading-none">
                AfroAm<span className="text-amber-400">.</span>
              </div>
            </div>
            <p className="text-neutral-400 max-w-sm mt-5 font-light leading-relaxed">
              One game. Two cultures. One family. Uniting African and American
              basketball — one court, one story, one continent at a time.
            </p>
            <div className="flex gap-4 mt-8">
              <a
                href="#"
                aria-label="Instagram"
                data-testid="social-instagram"
                className="w-11 h-11 border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-black hover:bg-white transition-colors"
              >
                <Instagram size={18} />
              </a>
              <a
                href="#"
                aria-label="Twitter"
                data-testid="social-twitter"
                className="w-11 h-11 border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-black hover:bg-white transition-colors"
              >
                <Twitter size={18} />
              </a>
              <a
                href="#"
                aria-label="YouTube"
                data-testid="social-youtube"
                className="w-11 h-11 border border-neutral-800 flex items-center justify-center text-neutral-400 hover:text-black hover:bg-white transition-colors"
              >
                <Youtube size={18} />
              </a>
            </div>
          </div>

          <div className="md:col-span-2 md:col-start-7">
            <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-4">
              Explore
            </div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li><a href="#about" className="hover:text-white">About</a></li>
              <li><a href="#programs" className="hover:text-white">Programs</a></li>
              <li><a href="#community" className="hover:text-white">Community</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-4">
              Connect
            </div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li><a href="#contact" className="hover:text-white">Contact</a></li>
              <li><a href="mailto:afroambasketball@gmail.com" className="hover:text-white">afroambasketball@gmail.com</a></li>
              <li><a href="https://afroamhoopsglobal.us" target="_blank" rel="noopener noreferrer" className="hover:text-white">afroamhoopsglobal.us</a></li>
              <li><a href="mailto:afroambasketball@gmail.com" className="hover:text-white">Press</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-4">
              Legal
            </div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li><a href="#" className="hover:text-white">Terms</a></li>
              <li><a href="#" className="hover:text-white">Privacy</a></li>
            </ul>
          </div>
        </div>

        <div className="font-display uppercase text-[18vw] leading-[0.85] text-white select-none whitespace-nowrap overflow-hidden">
          AFRO<span className="aa-outline-text">AM</span>
        </div>

        <div className="border-t border-neutral-900 pt-8 mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[10px] uppercase tracking-[0.3em] text-neutral-500">
          <div>© {new Date().getFullYear()} AfroAm Association. All rights reserved.</div>
          <div>Built in Las Vegas · Houston · San Francisco</div>
        </div>
      </div>
    </footer>
  );
};
